import { createSlice } from "@reduxjs/toolkit";
import {
  editStudentBuilder,
  fetchStudentsBuilder,
  signUpStudentBuilder,
} from "./builder";

const initialState = {
  students: {
    data: [],
    perPage: null,
    total: 0,
  },
  signUpStudentPending: false,
  fetchStudentsPending: false,
  editStudentPending: false,
};

export const studentSlice = createSlice({
  name: "studentInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    signUpStudentBuilder(builder);
    fetchStudentsBuilder(builder);
    editStudentBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

// export const {} = userSlice.actions;

export const selectStudents = (state) => state.studentInfo.students;
export const selectSignUpStudentPending = (state) =>
  state.studentInfo.signUpStudentPending;
export const selectEditStudentPending = (state) =>
  state.studentInfo.editStudentPending;

export default studentSlice.reducer;
